module.exports = __webpack_public_path__ + "media/bootstrap-icons/server-1af24a3c.svg";